import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class OrderFilterService {
  private orderId$ = new BehaviorSubject<number | null>(null);
  readonly orderId = this.orderId$.asObservable();

  setOrderId(orderId: number) {
    this.orderId$.next(orderId);
  }

  clear() {
    this.orderId$.next(null);
  }
}
